import { NumericFormat } from 'react-number-format'
import Num2persian from 'utilities/helper/num2Persian'
import { MIN_LOAN_AMOUNT } from 'pages/loans/add/utilities'

/**
 * «چقدر لازم داری؟» — one question, one control.
 *
 * The amount and the instalment count used to share a screen with the
 * priority dropdown, the note, the guarantor picker and the bank-card modal.
 * Splitting them is the whole point of the wizard: the number a member types
 * here is the one the fund will argue about, and it deserves the screen.
 */
export default function StepAmount({
    value,
    onChange,
    error,
}: {
    value: string
    onChange: (next: string) => void
    error?: string
}) {
    return (
        <div className=" rounded-2xl border border-stroke bg-white p-4">
            <NumericFormat
                thousandSeparator
                allowNegative={false}
                value={value}
                inputMode="numeric"
                placeholder="مبلغ وام (تومان)"
                className=" w-full border-b border-dashed border-stroke bg-transparent py-3 text-center text-lg font-bold outline-none"
                onValueChange={(values) => onChange(values.value)}
            />

            {value !== '' && (
                <p className=" mt-2 text-center text-xs text-blue-1">
                    {Num2persian(String(value))} تومان
                </p>
            )}

            {error && (
                <p className=" mt-2 text-center text-xs text-error-3">
                    {error}
                </p>
            )}

            <p className=" mt-3 text-center text-[11px] leading-6 text-text-secondary">
                حداقل مبلغ وام{' '}
                {MIN_LOAN_AMOUNT.toLocaleString('fa-IR')} تومان است.
            </p>
        </div>
    )
}
